export const SELECT_ACCOUNT_PARAM = 'prompt=select_account';
export const LOGIN_HINT_PARAM = 'login_hint';
export const ACCOUNT_SWITCH_PARAM = 'actSwt';
export const ACCOUNT_SWITCH_TYPE_PARAM = 'actSwtType';
export const ACCOUNT_SWITCH_SOURCE_PARAM = 'actSwtSrc';
export const ACCOUNT_SWITCH_START_PARAM = 'actSwtStartTs';
